Ext.define('SA.view.ImportProcessingIndicator', {
    constructor({maxDotCount}) {
        this.dotCount = 0;
        this.maxDotCount = maxDotCount;
    },

    getNext() {
        var previousDotCount = this.dotCount,
            resetRequired = previousDotCount === this.maxDotCount,
            currentDotCount = resetRequired ? 1 : previousDotCount + 1,
            dots = '.'.repeat(currentDotCount);

        this.dotCount = currentDotCount;

        return `<span class="sa-import-processing-indicator">${dots}</span>`;
    }
});